/**
 * Read CSRF token from the non-httpOnly csrf-token cookie.
 * Shared utility used by both api.ts and authService.ts.
 */
export function getCsrfToken(): string | null {
  try {
    const match = document.cookie.match(/(?:^|;\s*)csrf-token=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}
